var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-main-inner" },
    [
      _c(
        "el-dialog",
        {
          ref: "dialog",
          staticClass: "make-invoice-step-two-dialog",
          attrs: {
            visible: _vm.visible,
            title: _vm.title,
            width: "1100px",
            "close-on-click-modal": false,
            "show-close": false,
            top: "5vh"
          },
          on: {
            "update:visible": function($event) {
              _vm.visible = $event
            },
            open: _vm.showDialog
          }
        },
        [
          _vm.properties.isHedge
            ? _c(
                "div",
                {
                  staticClass: "app-main-inner-row",
                  staticStyle: { padding: "0 0 0 20px", height: "28px" }
                },
                [
                  _c(
                    "el-form",
                    {
                      attrs: {
                        inline: true,
                        "label-width": "60px",
                        "label-position": "right"
                      }
                    },
                    [
                      _c("span", { staticStyle: { "font-size": "14px" } }, [
                        _vm._v(_vm._s(_vm.$t("Invoice.invoice_receivables")))
                      ]),
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: _vm.$t("Invoice.invoice_currency") }
                        },
                        [
                          _c(
                            "el-radio-group",
                            {
                              staticClass: "h-dense-radio-group",
                              attrs: { no: "receivedRadio" },
                              on: { change: _vm.currencyRadioByReceivedChange },
                              model: {
                                value: _vm.properties.receivedRadio,
                                callback: function($$v) {
                                  _vm.$set(_vm.properties, "receivedRadio", $$v)
                                },
                                expression: "properties.receivedRadio"
                              }
                            },
                            [
                              _c("el-radio", { attrs: { label: "ALL" } }, [
                                _vm._v(_vm._s(_vm.$t("Invoice.invoice_all")))
                              ]),
                              _c("el-radio", { attrs: { label: "RMB" } }, [
                                _vm._v("RMB")
                              ]),
                              _c("el-radio", { attrs: { label: "USD" } }, [
                                _vm._v("USD")
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.visible
            ? _c(
                "div",
                {
                  staticClass: "app-main-inner-row row-grid",
                  staticStyle: { height: "420px", padding: "0" },
                  attrs: { id: "vsPage1" }
                },
                [
                  _vm.vsPage1_makeInvoiceMethod === 1 ||
                  _vm.vsPage1_makeInvoiceMethod === 2
                    ? _c("cargo-ag-grid", {
                        staticClass: "chargeGrid1",
                        staticStyle: { width: "100%" },
                        attrs: {
                          "config-module": "1906081",
                          "grid-params": _vm.chargeGrid.gridParams,
                          "grid-options": _vm.chargeGrid.gridOptions,
                          "column-defs": _vm.chargeGrid.columnDefs,
                          "row-data": _vm.vsPage1_rowData
                        },
                        on: {
                          "update:gridParams": function($event) {
                            return _vm.$set(
                              _vm.chargeGrid,
                              "gridParams",
                              $event
                            )
                          },
                          "update:grid-params": function($event) {
                            return _vm.$set(
                              _vm.chargeGrid,
                              "gridParams",
                              $event
                            )
                          },
                          gridReady: _vm.onGridReady_vsPage1
                        }
                      })
                    : _vm._e(),
                  _vm.vsPage1_makeInvoiceMethod === 3
                    ? _c("cargo-ag-grid", {
                        staticClass: "billingGrid1",
                        staticStyle: { width: "100%" },
                        attrs: {
                          "config-module": "1906082",
                          "grid-params": _vm.billingGrid.gridParams,
                          "grid-options": _vm.billingGrid.gridOptions,
                          "column-defs": _vm.billingGrid.columnDefs,
                          "row-data": _vm.vsPage1_rowData
                        },
                        on: {
                          "update:gridParams": function($event) {
                            return _vm.$set(
                              _vm.billingGrid,
                              "gridParams",
                              $event
                            )
                          },
                          "update:grid-params": function($event) {
                            return _vm.$set(
                              _vm.billingGrid,
                              "gridParams",
                              $event
                            )
                          },
                          gridReady: _vm.onGridReady_vsPage1
                        }
                      })
                    : _vm._e(),
                  _vm.vsPage1_makeInvoiceMethod === 4
                    ? _c("cargo-ag-grid", {
                        staticClass: "billingGroupGrid1",
                        staticStyle: { width: "100%" },
                        attrs: {
                          "config-module": "1906083",
                          "grid-params": _vm.billingGroupGrid.gridParams,
                          "grid-options": _vm.billingGroupGrid.gridOptions,
                          "column-defs": _vm.billingGroupGrid.columnDefs,
                          "row-data": _vm.vsPage1_rowData
                        },
                        on: {
                          "update:gridParams": function($event) {
                            return _vm.$set(
                              _vm.billingGroupGrid,
                              "gridParams",
                              $event
                            )
                          },
                          "update:grid-params": function($event) {
                            return _vm.$set(
                              _vm.billingGroupGrid,
                              "gridParams",
                              $event
                            )
                          },
                          gridReady: _vm.onGridReady_vsPage1
                        }
                      })
                    : _vm._e(),
                  _vm.vsPage1_makeInvoiceMethod === 5
                    ? _c("cargo-ag-grid", {
                        staticClass: "billingPaymentGrid1",
                        staticStyle: { width: "100%" },
                        attrs: {
                          "config-module": "1906084",
                          "grid-params": _vm.billingPaymentGrid.gridParams,
                          "grid-options": _vm.billingPaymentGrid.gridOptions,
                          "column-defs": _vm.billingPaymentGrid.columnDefs,
                          "row-data": _vm.vsPage1_rowData
                        },
                        on: {
                          "update:gridParams": function($event) {
                            return _vm.$set(
                              _vm.billingPaymentGrid,
                              "gridParams",
                              $event
                            )
                          },
                          "update:grid-params": function($event) {
                            return _vm.$set(
                              _vm.billingPaymentGrid,
                              "gridParams",
                              $event
                            )
                          },
                          gridReady: _vm.onGridReady_vsPage1
                        }
                      })
                    : _vm._e()
                ],
                1
              )
            : _vm._e(),
          _vm.properties.isHedge
            ? _c(
                "div",
                {
                  staticStyle: {
                    display: "flex",
                    "justify-content": "flex-end",
                    "padding-right": "10px",
                    "font-size": "12px",
                    "background-color": "#f5f7f7"
                  }
                },
                [
                  _c("span", {
                    domProps: {
                      textContent: _vm._s(_vm.$t("Invoice.invoice_subTotal"))
                    }
                  }),
                  _vm.reCalc
                    ? _c("charge-currency-total-group", {
                        key: 1,
                        attrs: {
                          mode: "group",
                          type: "ar",
                          "data-field": "amount",
                          "rate-field": "invoiceRate",
                          "currency-field": "currency",
                          "ar-field": _vm.arField,
                          "data-provider": _vm.charge1,
                          "amount-to-currency": _vm.properties.currency
                        }
                      })
                    : _vm._e()
                ],
                1
              )
            : _vm._e(),
          _vm.properties.isHedge
            ? _c(
                "div",
                {
                  staticClass: "app-main-inner-row",
                  staticStyle: { padding: "0 0 0 20px", height: "28px" }
                },
                [
                  _c(
                    "el-form",
                    {
                      attrs: {
                        inline: true,
                        "label-width": "60px",
                        "label-position": "right"
                      }
                    },
                    [
                      _c("span", { staticStyle: { "font-size": "14px" } }, [
                        _vm._v(_vm._s(_vm.$t("Invoice.invoice_payables")))
                      ]),
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: _vm.$t("Invoice.invoice_currency") }
                        },
                        [
                          _c(
                            "el-radio-group",
                            {
                              staticClass: "h-dense-radio-group",
                              attrs: { no: "paymentRadio" },
                              on: { change: _vm.currencyRadioByPaymentChange },
                              model: {
                                value: _vm.properties.paymentRadio,
                                callback: function($$v) {
                                  _vm.$set(_vm.properties, "paymentRadio", $$v)
                                },
                                expression: "properties.paymentRadio"
                              }
                            },
                            [
                              _c("el-radio", { attrs: { label: "ALL" } }, [
                                _vm._v(_vm._s(_vm.$t("Invoice.invoice_all")))
                              ]),
                              _c("el-radio", { attrs: { label: "RMB" } }, [
                                _vm._v("RMB")
                              ]),
                              _c("el-radio", { attrs: { label: "USD" } }, [
                                _vm._v("USD")
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.properties.isHedge && _vm.visible
            ? _c(
                "div",
                {
                  staticClass: "app-main-inner-row row-grid",
                  staticStyle: { height: "420px", padding: "0" },
                  attrs: { id: "vsPage2" }
                },
                [
                  _vm.vsPage2_makeInvoiceMethod === 1 ||
                  _vm.vsPage2_makeInvoiceMethod === 2
                    ? _c("cargo-ag-grid", {
                        staticClass: "chargeGrid2",
                        staticStyle: { width: "100%" },
                        attrs: {
                          "config-module": "1906085",
                          "grid-params": _vm.chargeGrid_vsPage2.gridParams,
                          "grid-options": _vm.chargeGrid_vsPage2.gridOptions,
                          "column-defs": _vm.chargeGrid.columnDefs,
                          "row-data": _vm.vsPage2_rowData
                        },
                        on: {
                          "update:gridParams": function($event) {
                            return _vm.$set(
                              _vm.chargeGrid_vsPage2,
                              "gridParams",
                              $event
                            )
                          },
                          "update:grid-params": function($event) {
                            return _vm.$set(
                              _vm.chargeGrid_vsPage2,
                              "gridParams",
                              $event
                            )
                          },
                          gridReady: _vm.onGridReady_vsPage2
                        }
                      })
                    : _vm._e(),
                  _vm.vsPage2_makeInvoiceMethod === 3
                    ? _c("cargo-ag-grid", {
                        staticClass: "billingGrid2",
                        staticStyle: { width: "100%" },
                        attrs: {
                          "config-module": "1906086",
                          "grid-params": _vm.billingGrid_vsPage2.gridParams,
                          "grid-options": _vm.billingGrid_vsPage2.gridOptions,
                          "column-defs": _vm.billingGrid.columnDefs,
                          "row-data": _vm.vsPage2_rowData
                        },
                        on: {
                          "update:gridParams": function($event) {
                            return _vm.$set(
                              _vm.billingGrid_vsPage2,
                              "gridParams",
                              $event
                            )
                          },
                          "update:grid-params": function($event) {
                            return _vm.$set(
                              _vm.billingGrid_vsPage2,
                              "gridParams",
                              $event
                            )
                          },
                          gridReady: _vm.onGridReady_vsPage2
                        }
                      })
                    : _vm._e(),
                  _vm.vsPage2_makeInvoiceMethod === 4
                    ? _c("cargo-ag-grid", {
                        staticClass: "billingGroupGrid2",
                        staticStyle: { width: "100%" },
                        attrs: {
                          "config-module": "1906087",
                          "grid-params":
                            _vm.billingGroupGrid_vsPage2.gridParams,
                          "grid-options":
                            _vm.billingGroupGrid_vsPage2.gridOptions,
                          "column-defs": _vm.billingGroupGrid.columnDefs,
                          "row-data": _vm.vsPage2_rowData
                        },
                        on: {
                          "update:gridParams": function($event) {
                            return _vm.$set(
                              _vm.billingGroupGrid_vsPage2,
                              "gridParams",
                              $event
                            )
                          },
                          "update:grid-params": function($event) {
                            return _vm.$set(
                              _vm.billingGroupGrid_vsPage2,
                              "gridParams",
                              $event
                            )
                          },
                          gridReady: _vm.onGridReady_vsPage2
                        }
                      })
                    : _vm._e(),
                  _vm.vsPage2_makeInvoiceMethod === 5
                    ? _c("cargo-ag-grid", {
                        staticClass: "billingPaymentGrid2",
                        staticStyle: { width: "100%" },
                        attrs: {
                          "config-module": "1906088",
                          "grid-params":
                            _vm.billingPaymentGrid_vsPage2.gridParams,
                          "grid-options":
                            _vm.billingPaymentGrid_vsPage2.gridOptions,
                          "column-defs": _vm.billingPaymentGrid.columnDefs,
                          "row-data": _vm.vsPage2_rowData
                        },
                        on: {
                          "update:gridParams": function($event) {
                            return _vm.$set(
                              _vm.billingPaymentGrid_vsPage2,
                              "gridParams",
                              $event
                            )
                          },
                          "update:grid-params": function($event) {
                            return _vm.$set(
                              _vm.billingPaymentGrid_vsPage2,
                              "gridParams",
                              $event
                            )
                          },
                          gridReady: _vm.onGridReady_vsPage2
                        }
                      })
                    : _vm._e()
                ],
                1
              )
            : _vm._e(),
          _vm.properties.isHedge
            ? _c(
                "div",
                {
                  staticStyle: {
                    display: "flex",
                    "justify-content": "flex-end",
                    "padding-right": "10px",
                    "font-size": "12px",
                    "background-color": "#f5f7f7"
                  }
                },
                [
                  _c("span", {
                    domProps: {
                      textContent: _vm._s(_vm.$t("Invoice.invoice_subTotal"))
                    }
                  }),
                  _vm.reCalc
                    ? _c("charge-currency-total-group", {
                        key: 2,
                        attrs: {
                          mode: "group",
                          type: "ap",
                          "data-field": "amount",
                          "rate-field": "invoiceRate",
                          "currency-field": "currency",
                          "ar-field": _vm.arField,
                          "data-provider": _vm.charge2,
                          "amount-to-currency": _vm.properties.currency
                        }
                      })
                    : _vm._e()
                ],
                1
              )
            : _vm._e(),
          _c(
            "div",
            {
              staticStyle: {
                width: "100%",
                display: "flex",
                "justify-content": "space-between",
                padding: "5px 10px",
                "font-size": "13px",
                "background-color": "#f5f7f7"
              }
            },
            [
              _c(
                "div",
                {
                  staticStyle: {
                    flex: "1",
                    display: "flex",
                    "flex-wrap": "wrap",
                    "justify-content": "flex-start"
                  }
                },
                [
                  _c(
                    "el-form",
                    {
                      staticStyle: { display: "inline-block" },
                      attrs: {
                        inline: true,
                        "label-width": "40px",
                        "label-position": "right"
                      }
                    },
                    [
                      _vm.properties.txtCurrency1 !== ""
                        ? _c(
                            "span",
                            { staticStyle: { "vertical-align": "middle" } },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("Invoice.invoice_currency")) + " "
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.properties.txtCurrency1 !== ""
                        ? _c(
                            "span",
                            {
                              staticStyle: {
                                "font-weight": "bold",
                                "vertical-align": "middle"
                              }
                            },
                            [
                              _vm._v(_vm._s(_vm.properties.txtCurrency1)),
                              _c("i", { staticClass: "el-icon-right" }),
                              _vm._v(_vm._s(_vm.properties.currency))
                            ]
                          )
                        : _vm._e(),
                      _vm.properties.txtCurrency1 !== ""
                        ? _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("Invoice.invoice_exchangeRate"),
                                "label-width": _vm.$selectByLang("", "95px")
                              }
                            },
                            [
                              _c("num-input", {
                                staticStyle: { width: "95px" },
                                attrs: {
                                  no: "txtRate1",
                                  precision: 8,
                                  "truncated-precision": _vm.txtRate1Precision,
                                  disabled: _vm.showCollectInvoiceWindow
                                },
                                on: { change: _vm.txtRate1Change },
                                model: {
                                  value: _vm.properties.txtRate1,
                                  callback: function($$v) {
                                    _vm.$set(_vm.properties, "txtRate1", $$v)
                                  },
                                  expression: "properties.txtRate1"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.properties.txtCurrency2 !== ""
                        ? _c(
                            "span",
                            { staticStyle: { "vertical-align": "middle" } },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("Invoice.invoice_currency")) + " "
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.properties.txtCurrency2 !== ""
                        ? _c(
                            "span",
                            {
                              staticStyle: {
                                "font-weight": "bold",
                                "vertical-align": "middle"
                              }
                            },
                            [
                              _vm._v(_vm._s(_vm.properties.txtCurrency2)),
                              _c("i", { staticClass: "el-icon-right" }),
                              _vm._v(_vm._s(_vm.properties.currency))
                            ]
                          )
                        : _vm._e(),
                      _vm.properties.txtCurrency2 !== ""
                        ? _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("Invoice.invoice_exchangeRate"),
                                "label-width": _vm.$selectByLang("", "95px")
                              }
                            },
                            [
                              _c("num-input", {
                                staticStyle: { width: "95px" },
                                attrs: {
                                  no: "txtRate2",
                                  precision: 8,
                                  "truncated-precision": _vm.txtRate2Precision,
                                  disabled: _vm.showCollectInvoiceWindow
                                },
                                on: { change: _vm.txtRate2Change },
                                model: {
                                  value: _vm.properties.txtRate2,
                                  callback: function($$v) {
                                    _vm.$set(_vm.properties, "txtRate2", $$v)
                                  },
                                  expression: "properties.txtRate2"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "div",
                {
                  staticStyle: {
                    display: "inline-block",
                    "text-align": "right",
                    "margin-right": "-10px"
                  }
                },
                [
                  _c("span", {
                    domProps: {
                      textContent: _vm._s(_vm.$t("Invoice.invoice_total"))
                    }
                  }),
                  _vm.reCalc
                    ? _c("charge-currency-total-group", {
                        key: 3,
                        attrs: {
                          mode: "group",
                          type: "revenueAbs",
                          "data-field": "amount",
                          "rate-field": "invoiceRate",
                          "currency-field": "currency",
                          source: "invoiceDetail",
                          "ar-field": _vm.arField,
                          "data-provider": _vm.allCharge,
                          "amount-to-currency": _vm.properties.currency,
                          "currency-conversion-in-invoices":
                            _vm.currencyConversionInInvoices
                        }
                      })
                    : _vm._e()
                ],
                1
              )
            ]
          ),
          !_vm.showCollectInvoiceWindow
            ? _c("div", { attrs: { slot: "footer" }, slot: "footer" }, [
                _c(
                  "span",
                  [
                    !_vm.properties.isHedge
                      ? _c(
                          "el-button",
                          {
                            attrs: {
                              disabled: _vm.properties.isEtowerOne,
                              no: "toAutoSplitCharge",
                              type: "primary"
                            },
                            on: { click: _vm.toAutoSplitCharge }
                          },
                          [_vm._v(_vm._s(_vm.$t("Invoice.AutoSplitCharge")))]
                        )
                      : _vm._e(),
                    _c(
                      "el-button",
                      {
                        attrs: {
                          type: "primary",
                          no: "toSplitCharge",
                          disabled: _vm.properties.isEtowerOne
                        },
                        on: { click: _vm.toSplitCharge }
                      },
                      [_vm._v(_vm._s(_vm.$t("Invoice.invoice_sp31")))]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary", no: "toLast" },
                        on: { click: _vm.toLast }
                      },
                      [_vm._v(_vm._s(_vm.$t("Invoice.invoice_back")))]
                    ),
                    _vm.unInvoiceCreate
                      ? _c(
                          "el-button",
                          {
                            attrs: { type: "primary", no: "doNexInvoice" },
                            on: { click: _vm.doNexInvoice }
                          },
                          [_vm._v(_vm._s(_vm.$t("Invoice.invoice_next")))]
                        )
                      : _vm._e(),
                    !_vm.unInvoiceCreate
                      ? _c(
                          "el-button",
                          {
                            attrs: { type: "primary", no: "doMakeInvoice" },
                            on: { click: _vm.doMakeInvoice }
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.isCollectInvoice
                                  ? _vm.$t(
                                      "Invoice.invoice_collectInvoiceConfirmation"
                                    )
                                  : _vm.$t(
                                      "Invoice.invoice_invoiceConfirmation"
                                    )
                              )
                            )
                          ]
                        )
                      : _vm._e(),
                    _c(
                      "el-button",
                      { attrs: { no: "cancel" }, on: { click: _vm.cancel } },
                      [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
                    )
                  ],
                  1
                )
              ])
            : _vm._e(),
          _vm.showCollectInvoiceWindow
            ? _c(
                "div",
                { staticStyle: { height: "470px", padding: "0" } },
                [
                  _c("collect-invoice-window", {
                    ref: "collectInvoiceWindow",
                    attrs: { properties: _vm.properties }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.showCollectInvoiceWindow
            ? _c(
                "div",
                {
                  staticClass: "dense-btns",
                  attrs: { slot: "footer" },
                  slot: "footer"
                },
                [
                  _c(
                    "span",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: {
                            type: "primary",
                            disabled: !(_vm.properties.currentPage > 1),
                            no: "108"
                          },
                          on: { click: _vm.btPreClickHandler }
                        },
                        [_vm._v(_vm._s(_vm.$t("Invoice.invoice_theLastPage")))]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: {
                            type: "primary",
                            disabled: !(
                              _vm.properties.currentPage <
                              _vm.properties.totalPage
                            ),
                            no: "109"
                          },
                          on: { click: _vm.btNextClickHandler }
                        },
                        [_vm._v(_vm._s(_vm.$t("Invoice.invoice_theNextPage")))]
                      ),
                      _c(
                        "span",
                        {
                          staticStyle: {
                            "font-size": "14px",
                            "margin-left": "6px"
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.properties.currentPage) +
                              " / " +
                              _vm._s(_vm.properties.totalPage)
                          )
                        ]
                      )
                    ],
                    1
                  ),
                  _c(
                    "span",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary", no: "toLast2" },
                          on: {
                            click: function($event) {
                              _vm.showCollectInvoiceWindow = false
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("Invoice.invoice_back")))]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary", no: "doMakeInvoice" },
                          on: { click: _vm.doMakeInvoice }
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.isCollectInvoice
                                ? _vm.$t(
                                    "Invoice.invoice_collectInvoiceConfirmation"
                                  )
                                : _vm.$t("Invoice.invoice_invoiceConfirmation")
                            )
                          )
                        ]
                      ),
                      _c(
                        "el-button",
                        { attrs: { no: "cancel" }, on: { click: _vm.cancel } },
                        [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
                      )
                    ],
                    1
                  )
                ]
              )
            : _vm._e()
        ]
      ),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          staticClass: "make-invoice-step-two-split-charge-dialog",
          attrs: {
            visible: _vm.splitChargeDialog.show,
            title: _vm.$t("CargoMsg.Cargo_Sp31"),
            width: "760px",
            "close-on-click-modal": false,
            "show-close": false
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.splitChargeDialog, "show", $event)
            }
          }
        },
        [
          _c(
            "el-form",
            {
              attrs: {
                inline: true,
                model: _vm.splitChargeDialog.splitChargeForm,
                "label-width": "70px",
                "label-position": "right"
              }
            },
            [
              _c(
                "div",
                { staticClass: "el-form-item-wrapper" },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("CargoMsg.Cargo_OriginalExpenseP")
                      }
                    },
                    [
                      _c("span", [
                        _vm._v(_vm._s(_vm.splitChargeDialog.charge.chargeName))
                      ])
                    ]
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("CargoMsg.Cargo_CurrencyP") } },
                    [
                      _c("span", [
                        _vm._v(_vm._s(_vm.splitChargeDialog.charge.currency))
                      ])
                    ]
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("CargoMsg.Cargo_TaxIncludedPriceP")
                      }
                    },
                    [
                      _c("span", [
                        _vm._v(_vm._s(_vm.splitChargeDialog.charge.amount))
                      ])
                    ]
                  )
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "el-form-item-wrapper" },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: _vm.$t("CargoMsg.Cargo_SplitExpenseP") }
                    },
                    [
                      _c("span", [
                        _vm._v(
                          _vm._s(_vm.splitChargeDialog.splitCharge.chargeName)
                        )
                      ])
                    ]
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("CargoMsg.Cargo_CurrencyP") } },
                    [
                      _c("span", [
                        _vm._v(
                          _vm._s(_vm.splitChargeDialog.splitCharge.currency)
                        )
                      ])
                    ]
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "custom-form-item-w",
                      attrs: {
                        label: _vm.$t("CargoMsg.Cargo_TaxIncludedPriceP")
                      }
                    },
                    [
                      _c("el-input-number", {
                        attrs: {
                          no: "amount",
                          precision: 2,
                          "controls-position": "right",
                          controls: false
                        },
                        on: { change: _vm.amountChangeHandler },
                        model: {
                          value: _vm.splitChargeDialog.splitCharge.amount,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.splitChargeDialog.splitCharge,
                              "amount",
                              $$v
                            )
                          },
                          expression: "splitChargeDialog.splitCharge.amount"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "custom-form-item-w",
                      attrs: {
                        label: _vm.$t("CargoMsg.Cargo_TaxExcludedPriceP")
                      }
                    },
                    [
                      _c("el-input-number", {
                        attrs: {
                          no: "excludingTaxAmount",
                          precision: 2,
                          min: -99999999,
                          max: 99999999,
                          "controls-position": "right",
                          disabled: true
                        },
                        model: {
                          value:
                            _vm.splitChargeDialog.splitCharge
                              .excludingTaxAmount,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.splitChargeDialog.splitCharge,
                              "excludingTaxAmount",
                              $$v
                            )
                          },
                          expression:
                            "splitChargeDialog.splitCharge.excludingTaxAmount"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "el-form-item-wrapper" },
                [
                  _c("el-form-item", { attrs: { label: " " } }),
                  _c("el-form-item", { attrs: { label: " " } }),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "custom-form-item-w",
                      attrs: { label: _vm.$t("CargoMsg.Cargo_TaxAmountP") }
                    },
                    [
                      _c("el-input-number", {
                        attrs: {
                          no: "taxAmount",
                          precision: 2,
                          min: -99999999,
                          max: 99999999,
                          "controls-position": "right",
                          disabled: true
                        },
                        model: {
                          value: _vm.splitChargeDialog.splitCharge.taxAmount,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.splitChargeDialog.splitCharge,
                              "taxAmount",
                              $$v
                            )
                          },
                          expression: "splitChargeDialog.splitCharge.taxAmount"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "custom-form-item-w",
                      attrs: { label: _vm.$t("CargoMsg.Cargo_TaxRateP") }
                    },
                    [
                      _c("el-input-number", {
                        attrs: {
                          no: "taxRate",
                          precision: 2,
                          min: -99999999,
                          max: 99999999,
                          "controls-position": "right",
                          disabled: true
                        },
                        model: {
                          value: _vm.splitChargeDialog.splitCharge.taxRate,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.splitChargeDialog.splitCharge,
                              "taxRate",
                              $$v
                            )
                          },
                          expression: "splitChargeDialog.splitCharge.taxRate"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ]
          ),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "span",
                {
                  staticStyle: {
                    position: "absolute",
                    left: "0",
                    "padding-left": "10px"
                  }
                },
                [
                  _c(
                    "el-checkbox",
                    {
                      attrs: { no: "onlyChangeQuantity" },
                      on: { change: _vm.onlyChangeQuantityChangeHandler },
                      model: {
                        value: _vm.splitChargeDialog.onlyChangeQuantity,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.splitChargeDialog,
                            "onlyChangeQuantity",
                            $$v
                          )
                        },
                        expression: "splitChargeDialog.onlyChangeQuantity"
                      }
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.$t(
                            "Invoice.invoice_SplitChargeOnlyChangeQuantity"
                          )
                        )
                      )
                    ]
                  )
                ],
                1
              ),
              _c(
                "el-button",
                {
                  attrs: {
                    no: "ok",
                    type: "primary",
                    disabled: _vm.splitChargeDialog.btnSplitEnable
                  },
                  on: { click: _vm.doSplitCharge }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.ok")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { no: "cancel" },
                  on: {
                    click: function($event) {
                      _vm.splitChargeDialog.show = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            visible: _vm.autoSplitChargeDialog.visible,
            title: _vm.$t("Invoice.AutoSplitCharge"),
            width: "630px",
            "close-on-click-modal": false,
            "show-close": false
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.autoSplitChargeDialog, "visible", $event)
            }
          }
        },
        [
          _c(
            "el-form",
            {
              attrs: {
                inline: true,
                model: _vm.autoSplitChargeDialog.chargeOrigin,
                "label-width": "90px",
                "label-position": "right"
              }
            },
            [
              _c(
                "div",
                {
                  staticStyle: {
                    "border-bottom": "1px solid #000000",
                    height: "100px"
                  }
                },
                [
                  _c(
                    "div",
                    { staticClass: "el-form-item-wrapper" },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("CargoMsg.Cargo_OriginalExpenseP")
                          }
                        },
                        [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.autoSplitChargeDialog.chargeOrigin
                                  .chargeName
                              )
                            )
                          ])
                        ]
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: _vm.$t("CargoMsg.Cargo_CurrencyP") }
                        },
                        [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.autoSplitChargeDialog.chargeOrigin.currency
                              )
                            )
                          ])
                        ]
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("CargoMsg.Cargo_TaxIncludedPriceP")
                          }
                        },
                        [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.autoSplitChargeDialog.chargeOrigin.amount
                              )
                            )
                          ])
                        ]
                      )
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "el-form-item-wrapper" },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("CargoMsg.Cargo_SplitExpenseP")
                          }
                        },
                        [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.autoSplitChargeDialog.chargeOrigin
                                  .chargeName
                              )
                            )
                          ])
                        ]
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: _vm.$t("CargoMsg.Cargo_CurrencyP") }
                        },
                        [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.autoSplitChargeDialog.chargeOrigin.currency
                              )
                            )
                          ])
                        ]
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("Invoice.IncludingTaxAmountLimit")
                          }
                        },
                        [
                          _c("el-input-number", {
                            attrs: {
                              precision: 2,
                              "controls-position": "right",
                              controls: false
                            },
                            on: {
                              change: function(p) {
                                _vm.autoSplitChargeDialog.confirmSplitEnable = true
                                _vm.maxAmountChangeHandler(p)
                              }
                            },
                            model: {
                              value: _vm.autoSplitChargeDialog.maxAmount,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.autoSplitChargeDialog,
                                  "maxAmount",
                                  $$v
                                )
                              },
                              expression: "autoSplitChargeDialog.maxAmount"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "div",
                    {
                      staticStyle: { "padding-bottom": "10px", float: "right" },
                      attrs: { slot: "footer" },
                      slot: "footer"
                    },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: {
                            no: "toAutoCalculateSplit",
                            type: "primary"
                          },
                          on: { click: _vm.toAutoCalculateSplit }
                        },
                        [_vm._v(_vm._s(_vm.$t("Invoice.AutoCalculateSplit")))]
                      )
                    ],
                    1
                  )
                ]
              ),
              _c(
                "div",
                { staticStyle: { "min-height": "310px" } },
                [
                  _c("h1", { staticStyle: { "font-size": "20px" } }, [
                    _vm._v(_vm._s(_vm.$t("Invoice.AutoCalculateSplitResult")))
                  ]),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("CargoMsg.Cargo_OriginalExpenseP")
                      }
                    },
                    [
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm.autoSplitChargeDialog.chargeOrigin.chargeName
                          )
                        )
                      ])
                    ]
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("CargoMsg.Cargo_CurrencyP") } },
                    [
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm.autoSplitChargeDialog.chargeOrigin.currency
                          )
                        )
                      ])
                    ]
                  ),
                  _c(
                    "div",
                    {
                      staticClass: "section grid-wrapper",
                      staticStyle: { "min-height": "200px" }
                    },
                    [
                      _c("cargo-ag-grid", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          "grid-options": _vm.autoSplitChargeDialog.gridOptions,
                          "column-defs": _vm.autoSplitChargeDialog.columnDefs,
                          "row-data": _vm.autoSplitChargeDialog.rowData,
                          "check-main-record": false,
                          "deselect-main-record": false,
                          "auto-fit-content": false
                        },
                        on: {
                          gridReady: function(params) {
                            _vm.autoSplitChargeDialog.gridApi = params.api
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "div",
                    {
                      staticStyle: { float: "right" },
                      attrs: { slot: "footer" },
                      slot: "footer"
                    },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: {
                            type: "primary",
                            no: "doAutoSplitCharge",
                            disabled:
                              _vm.autoSplitChargeDialog.confirmSplitEnable
                          },
                          on: { click: _vm.doAutoSplitCharge }
                        },
                        [_vm._v(_vm._s(_vm.$t("common.btn.ok")))]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { no: "autoSplitChargeDialogCancel" },
                          on: {
                            click: function($event) {
                              _vm.autoSplitChargeDialog.visible = false
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ]
          )
        ],
        1
      ),
      _vm.batchCheckingWindow.visible
        ? _c("batch-checking-window", {
            attrs: {
              visible: _vm.batchCheckingWindow.visible,
              lob: _vm.batchCheckingWindow.lob,
              jobs: _vm.batchCheckingWindow.jobs,
              "res-data": _vm.batchCheckingWindow.resData,
              "check-node": _vm.batchCheckingWindow.checkNode,
              "call-back": _vm.batchCheckingWindow.callBack
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.batchCheckingWindow, "visible", $event)
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }